import { FilterMethod } from "@/generated/company-search";

/**
 * Upload state machine states.
 * IDLE → UPLOADING → PROCESSING → SUCCESS/ERROR
 */
export type UploadState =
  | "IDLE"
  | "UPLOADING"
  | "PROCESSING"
  | "SUCCESS"
  | "ERROR";

export type UploadedAccountsSlice = {
  /** Current upload lifecycle state */
  uploadState: UploadState;
  /** Server-assigned file identifier */
  fileId: string | null;
  /** Original uploaded file name */
  fileName: string | null;
  /** Number of rows matched to companies */
  matchedRows: number | null;
  /** Number of rows that failed parsing/validation */
  invalidRows: number | null;
  /** Total rows in the uploaded file */
  totalRows: number | null;
  /** Whether to include corporate hierarchy in matching */
  includeHierarchy: boolean;
  /** Whether to suppress matches from a different country than the input */
  enforceCountryMatch: boolean;
  /** Whether to include (FILTER) or exclude (EXCLUDE_MATCHED) matched companies */
  filterMethod: FilterMethod;
  /** Error message when uploadState is ERROR */
  error: string | null;
  /** ISO timestamp when file was uploaded (from backend) */
  uploadedAt: string | null;
  /** ISO timestamp when matching completed (from backend) */
  matchedAt: string | null;
  /** Tier/RGIF flags the file was matched with (from backend). */
  isPlatformPermissible: boolean | null;
  isV1Dataset: boolean | null;
  rgifExclusiveCompany: boolean | null;
};

export const defaultUploadedAccountsSlice: UploadedAccountsSlice = {
  uploadState: "IDLE",
  fileId: null,
  fileName: null,
  matchedRows: null,
  invalidRows: null,
  totalRows: null,
  includeHierarchy: false,
  enforceCountryMatch: false,
  filterMethod: FilterMethod.FILTER,
  error: null,
  uploadedAt: null,
  matchedAt: null,
  isPlatformPermissible: null,
  isV1Dataset: null,
  rgifExclusiveCompany: null,
};
